import React from 'react';
import { createUseStyles } from 'react-jss';
import clsx from 'clsx';

const useStyles = createUseStyles({
    root: {
        padding: '0.6rem 2rem',
        fontSize: '1rem',
        backgroundColor: 'transparent',
        minWidth: '200px',
        borderImage: 'var(--button-url) round',
        borderImageSlice: '25 50 fill',
        borderImageWidth: '30px 48px',
        cursor: 'pointer',
        '&:not(:disabled):hover': {
            filter: 'hue-rotate(20deg)',
        },
        '&:disabled': {
            filter: 'grayscale(100%)',
            cursor: 'not-allowed',
        },
    },
});

export const Button: React.FunctionComponent<React.ButtonHTMLAttributes<HTMLButtonElement>> = props => {
    const classes = useStyles();

    return (
        <button {...props} className={clsx(classes.root, props.className)} />
    );
};
